import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-gamepad-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50 font-bold">
                黄游戏
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              最全的热门黄游戏推荐与攻略平台，汇聚最新游戏资讯、深度评测、实用攻略，助你畅享游戏世界。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              游戏分类
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">
              关注我们
            </h4>
            <p className="text-sm text-background-400 mb-4">
              获取最新游戏资讯和攻略更新
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 transition-colors cursor-pointer"
                aria-label="B站"
                rel="nofollow"
              >
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 黄游戏 huangyouxi.com All Rights Reserved.
          </p>
          <p className="text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer mr-4" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">
              用户协议
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}